<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<h1>{{ locale.translations['campaign']['n251'] }}</h1>

		<p>
			{{ locale.translations['campaign']['n252'] }}
		</p>

		<p>
			{{ locale.translations['campaign']['n253'] }}
		</p>
    </div>

    <div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="mdc-layout-grid__inner">
				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['logup']['signup']['n42'] }}</mat-label>
                        <input matInput required type="text" formControlName="name">
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['logup']['login']['n229'] }}</mat-label>
                        <input matInput required type="tel" (keyup)="onKeyUp('phone')" formControlName="phone">
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['logup']['login']['n43'] }}</mat-label>
                        <input matInput email required type="email" formControlName="email">
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['place-ad']['category']['n58'] }}</mat-label>
						<mat-select required formControlName="category">
							<mat-option *ngFor="let category of categories" value="{{ category['name'] }}">{{ category['name'] }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<mat-form-field appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['place-ad']['description']['n64'] }}</mat-label>

						<textarea matInput
						cdkTextareaAutosize
						#autosize="cdkTextareaAutosize"
						cdkAutosizeMinRows="5"
						cdkAutosizeMaxRows="10"
						formControlName="description"
						required></textarea>
					</mat-form-field>
				</div>

				<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
					<button mat-flat-button type="submit" color="primary" [disabled]="form.invalid || loading || this.form.controls['phone'].value.length == '1'">{{ locale.translations['place-ad']['finish']['n77'] }}</button>
				</div>
			</div>
		</form>
	</div>
</div>
